import { Button } from "antd";
import React, { useContext } from "react";
import "./index.scss";
import { DashboardContext } from "../../Context/DashboardContext";
import SlotPicker from "./SlotPicker";
import { useNavigate } from "react-router-dom";
import SlotDetails from "./SlotDetails";
import JobApplicationService from "../../Services/job.application.service";

const OnlineInterview: React.FC = () => {
  const { appliedJob, jobDescription, setAppliedJob } =
    useContext(DashboardContext);
  let isInterview = appliedJob?.status === "interview";
  let isScheduled = appliedJob?.interviewSchedule;
  let hasOnlineInterview = jobDescription?.onlineInterview;
  const navigate = useNavigate();

  if (!appliedJob || !jobDescription) {
    return null;
  }

  const fetchAppliedJob = async () => {
    if (appliedJob?._id) {
      const appJob = await new JobApplicationService().findJobApplicationById(
        appliedJob?._id
      );
      if (appJob) setAppliedJob(appJob);
    }
  };

  return (
    <>
      <div
        style={{
          padding: "24px",
        }}
      >
        {isInterview && isScheduled && <SlotDetails appliedJob={appliedJob} />}
        {isInterview && !isScheduled && hasOnlineInterview && (
          <SlotPicker
            onSlotBooked={() => {
              fetchAppliedJob();
            }}
          />
        )}
      </div>
    </>
  );
};

export default OnlineInterview;
